import React from 'react'

/* doc
---
title: CardContent
name: CardContent
category: React - Bulma
parent: Card
---

A `CardContent` component for adding content to a `Card`.

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Card>
    <CardContent>
      stuff
    </CardContent>
  </Card>
```
*/
function CardContent(props) {
  const { children, className, ...rest } = props

  const classes = [
    'card-content',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default CardContent
